// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recaptcha-footer-text[data-v-7497ae98]{background-color:transparent;width:100%;text-align:center;padding:15px;font-size:.85rem}", ""]);
// Exports
module.exports = exports;
